import mvolaLogo from "../assets/images/paiement/paiement-mvola.png";
import orangeLogo from "../assets/images/paiement/paiement-orangemoney.png";
import airtelLogo from "../assets/images/paiement/paiement-airtelmoney.png";
import visaLogo from "../assets/images/paiement/paiement-visa.png";

export const listeModePayement = [
  {
    methodPayment: 1,
    id: "mvola",
    label: "MVola",
    color: "#ffcc00",
    placeholder: "Numéro MVola",
    logo: mvolaLogo,
  },
  {
    methodPayment: 2,
    id: "orange",
    label: "Orange Money",
    color: "#ff6600",
    placeholder: "Numéro Orange Money",
    logo: orangeLogo,
  },
  {
    methodPayment: 3,
    id: "airtel",
    label: "Airtel Money",
    color: "#ed1c24",
    placeholder: "Numéro Airtel Money",
    logo: airtelLogo,
  },
  {
    methodPayment: 4,
    id: "cb",
    label: "Carte Bancaire",
    color: "#2c3e50",
    placeholder: "Numéro de carte",
    logo: visaLogo,
  },
];
